module.exports = __webpack_public_path__ + "img/Pic_ZS_YSDT.3e614a01.png";